var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center pt-2"},[_c('v-pagination',{key:`pagination-${_vm.currentPage}-${_vm.pageCount}`,attrs:{"model-value":_vm.currentPage,"length":_vm.pageCount,"total-visible":6,"next-icon":"fas fa-angle-right","prev-icon":"fas fa-angle-left"},on:{"update:model-value":_vm.handlePageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }